import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { Typography, Box } from '@weave-mui/material';

import { updateEnvironment } from 'store/actions/app_actions';

const HostingEnvironmentSwitch = ({ environments = [], context }) => {
  const dispatch = useDispatch();
  const environmentState = useSelector((state) => state.app.environment);
  const selectedEnv = environmentState[context];

  useEffect(() => {
    // if there are environments available
    if (environments.length) {
      // if there aren't any selected environments for context
      if (!selectedEnv) {
        dispatch(updateEnvironment(context, environments[0].env));
      }
      // if the selected environment is not in the environments array
      else if (!environments.find((e) => e.env === selectedEnv)) {
        dispatch(updateEnvironment(context, environments[0].env));
      }
    }
  }, [environments, context, selectedEnv, dispatch]);

  const onEnvChange = (option) => {
    if (option) {
      dispatch(updateEnvironment(context, option.value));
    }
  };

  if (!environments.length) {
    return null;
  }

  const options = environments.map((env) => ({
    value: env.env,
    label: env.displayName || env.displayname,
  }));

  const selectedOption =
    options.find((opt) => opt.value === selectedEnv) || null;

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '36px',
      height: '36px',
      minWidth: '120px',
      fontSize: '14px',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '36px',
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
      padding: '0px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '36px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '4px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#000000'
        : state.isFocused
        ? '#f5f5f5'
        : 'white',
      color: state.isSelected ? 'white' : 'black',
      '&:hover': {
        backgroundColor: state.isSelected ? '#000000' : '#f5f5f5',
      },
    }),
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography
        variant="body2"
        sx={{ whiteSpace: 'nowrap', fontWeight: 600 }}
      >
        Test Env
      </Typography>

      <Select
        value={selectedOption}
        onChange={onEnvChange}
        options={options}
        styles={customStyles}
        isSearchable={false}
      />
    </Box>
  );
};

HostingEnvironmentSwitch.propTypes = {
  environments: PropTypes.array,
  context: PropTypes.string.isRequired,
};

export default HostingEnvironmentSwitch;
